import React, { useContext } from 'react';

// DEFAULT AIG
import { ReactComponent as AIGSuccess } from '../../assets/images/claim-saved.svg';
import { ReactComponent as AIGContactUs } from '../../assets/images/Servicer_Icon.svg';
// HWA
import { ReactComponent as NJRSuccess } from '../../assets/images/Vendor/NJR/successful.svg';
import { ReactComponent as NJRContactUs } from '../../assets/images/Vendor/NJR/contactus.svg';

import { BrandingContext } from '../contexts/ContractContext';
import styles from './WhiteLabeling.module.css';

const BrandedIcon = ({ iconType }) => {
    const { clientId } = useContext(BrandingContext);

    const getIcon = () => {
        // REPEAT THIS "IF" FOR EACH NEW BRAND
        if (clientId === 'NJR') {
            if (iconType.toLowerCase() === 'success') return <NJRSuccess />;
            if (iconType.toLowerCase() === 'contactus') return <NJRContactUs />;
        }

        // FALLTHROUGH IF CLIENT NOT DEFINED OR NO MATCH FOUND
        if (iconType.toLowerCase() === 'success') return <AIGSuccess />;
        if (iconType.toLowerCase() === 'contactus') return <AIGContactUs />;

        // FALLTHROUGH IF NO MATCH ON CLIENT OR TYPE.
        return null;
    };

    return <div className={styles.variableIconWrapper}>{getIcon()}</div>;
};

export default BrandedIcon;
